export enum PanelPosition {
  Primary = 1,
  Secondary = 2,
  Hidden = 4,
}
